export const GROUP_NUMBER = {
	BBI_BROOKSHIRE_BROTHERS: 220,
	ICI_INTERCITY_INVESTMENTS: 188,
	PANHANDLE_FIRST_BANK: 225,
	PROGRESSIVE_LABORATORIES: 300,
	TEST_GROUP: 999
};

export const GROUP_NAME = {
	BBI: "Brookshire Brothers, Inc",
	ICI: "Intercity Investments",
	BOP: "Panhandle First Bank",
	PL: "Progressive Laboratories",
	TS: "Test Group"
};
